// import regex from '../../consts/regex';

const getRegexMatches = (regex, string) => {
  const matches = [];
  let m;

  while ((m = regex.exec(string)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex += 1;
    }

    // The result can be accessed through the `m`-variable.
    m.forEach((match) => {
      if (match !== 'null') {
        matches.push(match);
      }
    });
  }

  return matches;
};

const variableReplacement = (operation, objectWithReplacements) => {
  return operation.replace('this', objectWithReplacements.this);
  // return currentOperation.replaceAll(regex.VARIABLE, (variableName) => objectWithReplacements[variableName.substring(1)]);
};

const canReplaceAndEvaluate = (value, transform) => {
  const conditions = value !== null && value !== undefined && !Number.isNaN(value) && value !== '';
  return conditions && transform;
};

export default {
  getRegexMatches,
  variableReplacement,
  canReplaceAndEvaluate,
};
